import request from '../../../api/request';
import { StudyPlanTitulationDetail } from './type';

export function finantialOthersFormDataRequest() {
  return request<{
    certificateTypes: any[];
    petitionTypes: any;
    petitionPaymentTypes: any[];
    academicLevels: any[];
  }>(
    '/maintainers-portal/general-configuration/finantial-configuration-others/form-data',
  );
}

export function finantialOthersUpdateRequest(data: any) {
  return request(
    '/maintainers-portal/general-configuration/finantial-configuration-others',
    {
      method: 'PUT',
      data,
    },
  );
}

const BASE =
  '/maintainers-portal/general-configuration/finantial-configuration-others';

export function studyPlanTitulationListRequest(academicLevelId: number) {
  return request<StudyPlanTitulationDetail>(
    `${BASE}/academic-levels/${academicLevelId}/study-plans`,
  );
}

export function studyPlanTitulationUpdateRequest(
  academicLevelId: number,
  data: {
    paymentRequired: boolean;
    paymentAmount?: number;
    titulationPaymentId?: number | null;
    studyPlans: {
      studyPlanId: number;
      hasOverride: boolean;
      paymentAmount?: number;
    }[];
  },
) {
  return request(`${BASE}/academic-levels/${academicLevelId}/study-plans`, {
    method: 'PUT',
    data,
  });
}
